module.exports = "/_next/static/images/ba8f4220a898de97808d5be91e35911e-blog1-lg.png.webp";